/**
 * @generated SignedSource<<3e9e5cf9c4d4ad3aaec49930f417a94a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ToggleAsanaUserIncludeAIInput = {
  clientMutationId?: string | null;
  includeAi: boolean;
};
export type AsanaIntegrationToggleAsanaUserIncludeAiMutation$variables = {
  input: ToggleAsanaUserIncludeAIInput;
};
export type AsanaIntegrationToggleAsanaUserIncludeAiMutation$data = {
  readonly toggleAsanaUserIncludeAi: {
    readonly ok: boolean;
  } | null;
};
export type AsanaIntegrationToggleAsanaUserIncludeAiMutation = {
  response: AsanaIntegrationToggleAsanaUserIncludeAiMutation$data;
  variables: AsanaIntegrationToggleAsanaUserIncludeAiMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToggleAsanaUserIncludeAIPayload",
    "kind": "LinkedField",
    "name": "toggleAsanaUserIncludeAi",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaIntegrationToggleAsanaUserIncludeAiMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AsanaIntegrationToggleAsanaUserIncludeAiMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0cc9651c5f8fb2639e8f26fb3b5fd700",
    "id": null,
    "metadata": {},
    "name": "AsanaIntegrationToggleAsanaUserIncludeAiMutation",
    "operationKind": "mutation",
    "text": "mutation AsanaIntegrationToggleAsanaUserIncludeAiMutation(\n  $input: ToggleAsanaUserIncludeAIInput!\n) {\n  toggleAsanaUserIncludeAi(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c7713dc30321bd0033df20bb36d183e";

export default node;
